type IgnoreRule = string | RegExp;

/**
 * 上报忽略规则
 *·
 * 你可以通过string或者正则来匹配要过滤上报的信息，可以匹配errorClass、errorMessage以及userAgent
 *
 * 例如：[/micromessenger/i, 'UnhandledRejection', /^Failed to execute 'insertBefore' on 'Node'/]
 */
export const rules = [
    /UnhandledRejection/i,
    // https://app.bugsnag.com/tigerbrokers/fed-tiger-open-account/errors/5c55f2593ff44c0019ed5ffb
    /^Blocked a frame with origin/
] as IgnoreRule[];

export default function ignore(event) {
    const infos = [
        event.errors[0]?.errorClass,
        event.errors[0]?.errorMessage,
        (event.device && event.device.userAgent) || ''
    ];

    if (
        rules.some(rule => {
            if (typeof rule === 'string') {
                return infos.some(info => info === rule);
            }

            if (rule instanceof RegExp) {
                return infos.some(info => rule.test(info));
            }

            return false;
        })
    ) {
        return false;
    }

    return true;
}
